// extracted by mini-css-extract-plugin
export var custom = "ReviewIcons-module--custom--8228b";
export var large = "ReviewIcons-module--large--a6163";
export var medium = "ReviewIcons-module--medium--a0290";
export var small = "ReviewIcons-module--small--d14ea";